import { cn } from '@/lib/utils';
import SensayLogo from '@/public/logos/sensay-logo.svg';
import Link from 'next/link';
function Footer({
  className,
  hideBranding = false
}: {
  className?: string;
  hideBranding?: boolean;
}) {
  if (hideBranding) return null;
  return <Link className={cn('sensay-brand-link bg-background p-2 text-center bottom-0 z-10 flex items-center justify-center text-foreground/20 border-t border-foreground/10', className)} href="https://sensay.io/ai-chatbot" target="blank" data-sentry-element="Link" data-sentry-component="Footer" data-sentry-source-file="footer.tsx">
      <span className="text-xs">Powered by</span>
      <div className="ml-1 mt-1">
        <SensayLogo className="w-[45px] fill-current" data-sentry-element="SensayLogo" data-sentry-source-file="footer.tsx" />
      </div>
    </Link>;
}
export default Footer;